document.addEventListener('DOMContentLoaded', function () {
  var splide = null;
  var mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  var splideElement = document.querySelector('.product-cards-slider__mobile .splide');

  function initSplide() {
    if (splideElement) {
      if (splide) splide.destroy();
      
      splide = new Splide(splideElement, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: true,
        arrows: true,
        trimSpace: false,
        focus: 0,
        padding: { right: '15%' }
      });

      splide.mount();
    }
  }

  function handleMediaQueryChange(e) {
    if (e.matches) {
      // Mobile view
      initSplide();
    } else {
      // Desktop view
      if (splide) {
        splide.destroy();
        splide = null;
      }
    }
  }

  // Initial check
  handleMediaQueryChange(mobileMediaQuery);

  // Add listener for viewport changes
  mobileMediaQuery.addListener(handleMediaQueryChange);

  // Add to cart functionality
  document.querySelectorAll('.product-cards-slider__button--add').forEach(function(button) {
    button.addEventListener('click', function() {
      var productId = this.getAttribute('data-product-id');
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  
  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productId = this.dataset.productId;
      const quantityInput = document.getElementById(this.dataset.quantityId);
      const quantity = quantityInput ? quantityInput.value : 1;
      
      const cartObject = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      let formData = new FormData();
      formData.append('items[][id]', productId);
      formData.append('items[][quantity]', quantity);

      // Append to Cart object, used for renderContents
      if (cartObject) {
        formData.append(
          'sections',
          cartObject.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (!cartObject) return;
        cartObject.classList.remove('is-empty');
        cartObject.renderContents(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });
});